import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainedButton } from 'components/ContainedButton';
import { TFunction } from 'i18next';
import React from 'react';

type Props = {
  t: TFunction,
  isValid: boolean,
  openCreateProrationModal: () => void,
  disableAddProration: boolean,
  showAddProration: boolean
};

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  headerTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  titleContainer: {
    minWidth: 0,
  },
  addButtonContainer: {
    flexShrink: 0,
  },
}));

export const Header = ({ t, isValid, openCreateProrationModal, disableAddProration, showAddProration }: Props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      justifyContent="space-between"
      className={classes.headerContainer}
    >
      <Grid item xs className={classes.titleContainer}>
        <Typography variant="h5" className={classes.headerTitle}>
          {t('taxesAndProrations:taxes-and-prorations')}
        </Typography>
      </Grid>

      {showAddProration && (
        <Grid item className={classes.addButtonContainer}>
          <ContainedButton
            text={t('common:add')}
            icon="plus"
            onClick={openCreateProrationModal}
            disabled={disableAddProration}
          />
        </Grid>
      )}
    </Grid>
  );
};
